import PropTypes from 'prop-types';
import cn from 'classnames';
import { forwardRef } from 'react';

const LdsSwitch = forwardRef(function LdsSwitch({
  id,
  name,
  value,
  onByDefault = false,
  required = false,
  label,
  disabled = false,
  positiveText = 'On',
  negativeText = 'Off',
  labelPlacement = 'left',
  className,
  inputAttributes,
  ...rest
}, ref) {
  function toggleSwitch(e) {
    const isChecked = e.currentTarget.checked;
    e.currentTarget.setAttribute('aria-checked', isChecked);
  }

  return (
    <div
      className={cn(
        'lds-switch lds-form-field',
        {
          disabled,
        },
        className
      )}
      {...rest}
    >
      <label htmlFor={id} className="lds-switch-label">
        {labelPlacement !== 'right' && label}
        <input
          ref={ref}
          type="checkbox"
          name={name || id}
          className="lds-switch-input"
          value={value}
          id={id}
          disabled={disabled}
          required={required}
          defaultChecked={onByDefault}
          role="switch"
          aria-labelledby={id}
          aria-checked={onByDefault}
          onChange={toggleSwitch}
          {...inputAttributes}
        />
        <span aria-hidden="true" className={`lds-switch-toggle ${labelPlacement === 'right' ? 'lds-switch-label-right' : ''}`} >
          <span className="lds-switch-toggle-positive add-margin-right">
            {positiveText}
          </span>
          <span className="lds-switch-toggle-knob"></span>
          <span className="lds-switch-toggle-negative"> {negativeText} </span>
        </span>
        {labelPlacement === 'right' && label}
      </label>
    </div>
  );
});

LdsSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
  onByDefault: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  positiveText: PropTypes.string,
  negativeText: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['left', 'right']),
};

export default LdsSwitch;
